<div class="profile-card profile-card--read-only" *ngIf="hirings.length">
  <ng-container *ngFor="let hiring of hirings; let index = index">
    <div class="profile-card__item">
      <div class="profile-card__header">
        <h3 class="profile-card__title">
          <ng-container *ngIf="hiring.position; else companyNameTitle">
            {{ hiring.position }}
          </ng-container>
          <ng-template #companyNameTitle>
            <ng-container *ngIf="hiring.companyName; else defaultTitle">
              {{ hiring.companyName }}
            </ng-container>
            <ng-template #defaultTitle>
              {{ "admin.talent-view.hiring.title" | translate }}
            </ng-template>
          </ng-template>
        </h3>
      </div>
      <div class="profile-card__body">
        <div nz-row [nzGutter]="[20, 20]">
          <ng-container *ngIf="hiring.companyName">
            <div nz-col [nzSpan]="24" [nzMd]="8">
              <h4 class="profile-card__item-label">{{ "inbox.agreementTerms.companyName.label" | translate }}</h4>
              <p class="profile-card__item-value">
                {{ hiring.companyName }}
              </p>
            </div>
          </ng-container>

          <ng-container *ngIf="hiring.position">
            <div nz-col [nzSpan]="24" [nzMd]="8">
              <h4 class="profile-card__item-label">{{ "inbox.agreementTerms.position.label" | translate }}</h4>
              <p class="profile-card__item-value">
                {{ hiring.position }}
              </p>
            </div>
          </ng-container>

          <ng-container *ngIf="hiring.date">
            <div nz-col [nzSpan]="24" [nzMd]="8">
              <h4 class="profile-card__item-label">{{ "inbox.agreementTerms.date.label" | translate }}</h4>
              <p class="profile-card__item-value">
                {{ hiring.date | date : "dd.MM.YYYY" }}
              </p>
            </div>
          </ng-container>

          <ng-container *ngIf="hiring.salary">
            <div nz-col [nzSpan]="24" [nzMd]="8">
              <h4 class="profile-card__item-label">{{ "inbox.agreementTerms.salary.label" | translate }}</h4>
              <p class="profile-card__item-value">
                {{ hiring.salary }}
              </p>
            </div>
          </ng-container>

          <ng-container *ngIf="hiring.bonus">
            <div nz-col [nzSpan]="24" [nzMd]="8">
              <h4 class="profile-card__item-label">{{ "inbox.agreementTerms.bonus.label" | translate }}</h4>
              <p class="profile-card__item-value">
                {{ hiring.bonus }}
              </p>
            </div>
          </ng-container>

          <ng-container *ngIf="hiring.workingHours">
            <div nz-col [nzSpan]="24" [nzMd]="8">
              <h4 class="profile-card__item-label">{{ "inbox.agreementTerms.workingHours.label" | translate }}</h4>
              <p class="profile-card__item-value">
                {{ hiring.workingHours }}
              </p>
            </div>
          </ng-container>

          <ng-container *ngIf="hiring.placeOfWork">
            <div nz-col [nzSpan]="24" [nzMd]="8">
              <h4 class="profile-card__item-label">{{ "inbox.agreementTerms.placeOfWork.label" | translate }}</h4>
              <p class="profile-card__item-value">
                {{ hiring.placeOfWork }}
              </p>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>
</div>
